(ns frontend.view.grid.holdings-grid.columns)

;;default set of selected columns
(def ordered-default-columns
  [:holding/name
   :holding/cur-paid-in-capital
   :holding/cur-distributions
   :holding/cur-residual-value
   :holding/owner])

(def default-columns
  (set ordered-default-columns))

(def my-holdings-ordered-columns
  [:holding/name
   :holding/cur-paid-in-capital
   :holding/cur-distributions
   :holding/cur-residual-value])

(def my-holdings-columns
  (set my-holdings-ordered-columns))

;;always selected:
(def mandatory?
  #{:holding/name})
